@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/master-kush-strain-index-card-stack-content/master-kush-strain-price/master-kush-strain-price.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
::ng-deep .product-variant-price {
  position: relative;
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 1.375rem;
  letter-spacing: -0.42px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  line-height: 100%;
  overflow: visible;
}
::ng-deep .product-variant-price .product-variant-previous-price {
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 1.125rem;
  letter-spacing: -0.21px;
  opacity: 0.5;
  line-height: 100%;
  overflow: visible;
}
::ng-deep .product-variant-price .force-bold-style {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: normal;
}
::ng-deep .product-variant-price .force-italic-style {
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  font-style: italic;
}
/*# sourceMappingURL=master-kush-strain-price.component.css.map */
